import { localStore } from "./store"

interface EnvironmentConfig {
  BASE_API_URL: { gated: string; park: string; reserve: string }
}

export type APIMode = keyof EnvironmentConfig["BASE_API_URL"]

export const ENV = import.meta.env.MODE || "development"
const ENV_API_MODE = import.meta.env.VITE_APP_API_MODE || ""

export function resolveApiMode(): APIMode {
  if (ENV === "production") {
    console.log("ENV: ", ENV)
    switch (location.hostname) {
      case "sambapark.ipctg.com":
        return "park"

      case "app.tapnpark.com":
        return "park"

      case "app.tapnfly.com":
        return "gated"

      case "reserve.inflowparking.com":
        return "reserve"
    }
  }

  if (ENV === "staging") {
    console.log("ENV: ", ENV)
    switch (location.hostname) {
      case "reserve.staging.ipctg.com":
        return "reserve"
    }
  }

  if (ENV === "development") {
    console.log("ENV: ", ENV)
    switch (location.hostname) {
      case "park.ipctg.com":
      case "sambapark.ipctg.com":
      case "sambapark.tapnpark.com":
        return "park"
      case "gated.ipctg.com":
      case "samba.ipctg.com":
      case "sambafly.tapnfly.com":
        return "gated"
      case "reserve.ipctg.com":
        return "reserve"
    }
  }

  if (
    ENV_API_MODE === "gated" ||
    ENV_API_MODE === "park" ||
    ENV_API_MODE === "reserve"
  ) {
    console.log("ENV_API_MODE: ", ENV_API_MODE)
    return ENV_API_MODE
  }

  const manualMode = localStore.getItem("appAPI")
  if (
    manualMode === "gated" ||
    manualMode === "park" ||
    manualMode === "reserve"
  ) {
    console.log("manualMode: ", manualMode)
    return manualMode
  }

  // Default to gated
  return "gated"
}

const configs: Record<string, EnvironmentConfig> = {
  development: {
    BASE_API_URL: {
      gated: "https://gated.dev.inflowservice.com",
      park: "https://park.dev.inflowservice.com",
      reserve: "https://reserve.dev.inflowservice.com",
    },
  },
  staging: {
    BASE_API_URL: {
      gated: "https://gated.staging.inflowservice.com",
      park: "https://park.staging.inflowservice.com",
      reserve: "https://reserve.staging.inflowservice.com",
    },
  },
  production: {
    BASE_API_URL: {
      gated: "https://gated.prod.inflowservice.com",
      park: "https://park.prod.inflowservice.com",
      reserve: "https://reserve.prod.inflowservice.com",
    },
  },
}

const config: EnvironmentConfig = configs[ENV] || configs.development

export const BASE_API_URL = config.BASE_API_URL
